// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-tips[data-v-186bb783]{position:absolute;top:10px;right:18px;width:14px;height:14px;display:block;z-index:100}.KanbanDropdown[data-v-186bb783]{padding:6px 0 7px 0!important;width:92px!important}.KanbanDropdown .el-dropdown-menu__item[data-v-186bb783]{font-size:12px!important;padding-left:10px!important;color:#3e3e3c!important;line-height:28px!important}.KanbanDropdown .el-dropdown-menu__item[data-v-186bb783]:hover{background:#f3f2f2;color:#006dcc!important}", ""]);
// Exports
module.exports = exports;
